import React from "react"
import PropTypes from "prop-types"
import Avatar from "../avatar"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStar } from "@fortawesome/pro-regular-svg-icons"
import PersonDetails from "./PersonDetails"
import {
  Container,
  TopBanner,
  DisplayName,
  PlacementOrInterviewStatus,
  InfoBox,
  NameAndStatus,
  OtherInfo,
  Name,
  Badge,
  DesktopOnly
} from "./styles"

const ProfileInfo = ({
  age,
  avatarExists,
  avatarUrl,
  obfuscated,
  firstName,
  lastName,
  smallOnMobile,
  displayName,
  placementOrInterviewStatus,
  employerName,
  employerHighlyRated,
  employerLocation,
  employerType,
  hasCoverImage,
  country,
  gender,
  pronouns
}) => (
  <Container smallOnMobile={smallOnMobile} hasEmployer={!!employerName}>
    {!!employerName ? (
      <>
        {avatarUrl !== undefined && (
          <Avatar
            avatarExists={avatarExists}
            src={avatarUrl}
            obfuscated={obfuscated}
            alt={employerName ? employerName : `${firstName} ${lastName}`}
            smallOnMobile={smallOnMobile}
            firstName={firstName}
            lastName={lastName}
            noBorder
            profile
          />
        )}
        <InfoBox hasCoverImage={hasCoverImage}>
          <>
            <NameAndStatus>
              <Name>{employerName}</Name>
              {employerHighlyRated && (
                <Badge>
                  <FontAwesomeIcon icon={faStar} /> Rated Highly By Former Staff
                </Badge>
              )}
            </NameAndStatus>
            <OtherInfo employer>
              {employerLocation && <div>{employerLocation}</div>}
              {employerType && (
                <>
                  <DesktopOnly>·</DesktopOnly>
                  <div>{employerType}</div>
                </>
              )}
            </OtherInfo>
          </>
        </InfoBox>
      </>
    ) : (
      <TopBanner>
        <DisplayName>{displayName}</DisplayName>
        {placementOrInterviewStatus && (
          <PlacementOrInterviewStatus>{placementOrInterviewStatus}</PlacementOrInterviewStatus>
        )}
        <PersonDetails age={age} gender={gender} country={country} pronouns={pronouns} />
      </TopBanner>
    )}
  </Container>
)

ProfileInfo.propTypes = {
  avatarExists: PropTypes.bool,
  avatarUrl: PropTypes.string,
  obfuscated: PropTypes.bool,
  name: PropTypes.string,
  subtext: PropTypes.string,
  placeItems: PropTypes.string,
  avatarSize: PropTypes.string,
  smallOnMobile: PropTypes.bool,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  handleDownloadBtn: PropTypes.func,
  handleMessagingBtn: PropTypes.func,
  employerHighlyRated: PropTypes.bool
}

ProfileInfo.defaultProps = {
  avatarExists: true,
  avatarUrl: undefined,
  obfuscated: false,
  name: "",
  subtext: "",
  placeItems: undefined,
  avatarSize: "default",
  smallOnMobile: false,
  firstName: "",
  lastName: "",
  employerHighlyRated: false
}

export default ProfileInfo
